import { Search } from "lucide-react";
import { useState } from "react";
import { LeadBadge } from "@/components/admin/LeadBadge";

const fmtDate = (iso) => new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });
const th = "text-left font-medium px-4 py-3";

export default function LeadsTable({ leads, onSelect, showSchool = false, children }) {
  const [q, setQ] = useState("");
  const filtered = (leads || []).filter((l) =>
    [l.parent_name, l.phone, l.course, l.school_name].join(" ").toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="bg-white rounded-2xl border overflow-hidden">
      <div className="p-4 border-b flex flex-wrap items-center gap-3">
        <div className="flex-1 min-w-[200px] flex items-center gap-2">
          <Search className="w-4 h-4 text-stone-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name, phone or course"
            className="flex-1 outline-none text-sm bg-transparent" data-testid="lead-search-input" />
        </div>
        {children}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="lead-table">
          <thead className="bg-stone-50 text-stone-500 text-xs uppercase tracking-wide">
            <tr>
              <th className={th}>Parent</th>
              {showSchool && <th className={th}>School</th>}
              <th className={th}>Phone</th>
              <th className={th}>Course</th>
              <th className={th}>Preferred timing</th>
              <th className={th}>Label</th>
              <th className={`${th} hidden md:table-cell`}>Source</th>
              <th className={`${th} hidden md:table-cell`}>Received</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((l) => (
              <tr key={l.id} onClick={() => onSelect(l)} data-testid={`lead-row-${l.id}`}
                className="border-t cursor-pointer hover:bg-stone-50 transition-colors">
                <td className="px-4 py-3 font-medium whitespace-nowrap">{l.parent_name}</td>
                {showSchool && <td className="px-4 py-3 whitespace-nowrap" data-testid="lead-row-school">{l.school_name}</td>}
                <td className="px-4 py-3 whitespace-nowrap">{l.phone}</td>
                <td className="px-4 py-3 whitespace-nowrap">{l.course || "—"}</td>
                <td className="px-4 py-3 min-w-[160px] text-stone-600">{l.timing || "—"}</td>
                <td className="px-4 py-3"><LeadBadge label={l.label} /></td>
                <td className="px-4 py-3 hidden md:table-cell text-stone-500 capitalize">{l.source === "form" ? "Form" : "Chat"}</td>
                <td className="px-4 py-3 text-stone-500 whitespace-nowrap hidden md:table-cell">{fmtDate(l.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {leads && filtered.length === 0 && (
          <p className="text-center text-stone-500 text-sm py-14" data-testid="leads-empty-state">
            {leads.length === 0 ? "No enquiries yet. They'll appear here once parents chat or fill the enquiry form." : "No leads match your search."}
          </p>
        )}
        {!leads && <p className="text-center text-stone-400 text-sm py-14">Loading leads…</p>}
      </div>
    </div>
  );
}
